var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h1',{staticClass:"visually-hidden"},[_vm._v("Welcome to Baron - Your Gateway to Success")]),_c('navbar'),_c('section',[_c('router-view',{class:{'pageContent': _vm.isLoginPage}})],1),_c('footersection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }